<template>
    <a v-if="isTelephoneOrMail" :href="uri" v-html="text" />
    <span v-else>
        <a :href="uri" v-html="text" @click.prevent="dialog = true"> </a>
        <external-link-dialog
            :link="uri"
            :dialog="dialog"
            @close="dialog = false"
        />
    </span>
</template>

<script>
import ExternalLinkDialog from '@/components/dialogs/external-link-dialog'
export default {
  name: 'CtfRichTextExternalLink',
  components: {
    ExternalLinkDialog
  },
  props: {
    text: {
      type: String,
      required: true
    },
    uri: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    isTelephoneOrMail () {
      return this.uri.includes('tel:') || this.uri.includes('mailto:')
    }
  }
}
</script>
